import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      isSineDieFromEntregaDePropostas: 'isSineDieFromEntregaDePropostas',
    }),
    pregaoEditarOfertaCompra() {
      return this.auction || this.ofertaCompra;
    },
  },
  methods: {
    disableFields() {
      if (this.isSineDieFromEntregaDePropostas) return false;
      const oferta = this.pregaoEditarOfertaCompra;
      return !!(oferta?.situacao && oferta.situacao.id > 3);
    },
    isSessaoAbertaParaEdicao() {
      if (this.isSineDieFromEntregaDePropostas) return false;
      return this.pregaoEditarOfertaCompra?.situacao?.id > 4;
    },
  },
};
